<template>
  <div id="searchOptions">
    <el-form :inline="true" :model="form" ref="ruleForm" label-width="70px">
      <el-row>
        <el-form-item prop="printStatus" v-if="curComponent =='waybillDetailPage'">
          <span @click="goback" class="y-fc-4C84FF y-pr-15 y-c-p"><< 返回</span>
        </el-form-item>
        <template v-if="curComponent !=='waybillDetailPage'">
          <el-form-item prop="queryDateType">
            <el-select :popper-append-to-body="false" class="y-w-136" v-model="form.queryDateType" placeholder="请选择">
              <el-option label="建包时间" value="0" v-if="curComponent == 'PACKAGE_PRINT'"></el-option>
              <el-option label="揽收时间" value="1" v-if="curComponent == 'BULK_PRINT'"></el-option>
              <el-option label="上车时间" value="1" v-if="curComponent == 'PACKUP_PACKAGE'"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="createTime">
            <yto-date-picker
              :maxRangeVal="7"
              :customDaysName="`JBDY_${this.curComponent}_customrange`"
              :curShortcutName="curShortcutName"
              :clearable="false"
              :editable="false"
              :picker-options="pickerOptions1"
              v-model="form.createTime"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy.MM.dd HH:mm">
            </yto-date-picker>
          </el-form-item>
          <el-form-item label="" prop="mallCode">
            <el-select class="y-w-136" :popper-append-to-body="false" v-model="form.mallCode" placeholder="请选择店铺">
              <el-option
                v-for="(item, index) in storList"
                :key="index"
                :label="item.shopName"
                :value="item.shopCode+''"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="pickupStatus" v-if="curComponent !== 'PACKUP_PACKAGE'">
            <el-select class="y-w-136" :popper-append-to-body="false" v-model="form.pickStatus" placeholder="上车状态" :clearable="true">
              <el-option label="待上车" value="0"></el-option>
              <el-option label="上车失败" value="-1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="printStatus" v-if="curComponent !== 'PACKUP_PACKAGE'">
            <el-select class="y-w-136" :popper-append-to-body="false" v-model="form.printStatus" placeholder="打印状态" :clearable="true">
              <el-option label="待打印" value='0'></el-option>
              <el-option label="已打印" value='1'></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="buildPackageType" v-if="curComponent == 'PACKAGE_PRINT'">
            <el-select class="y-w-136" :popper-append-to-body="false" v-model="form.buildPackageType" placeholder="建包类型" :clearable="true">
              <el-option label="自动建包" value='0'></el-option>
              <el-option label="手动建包" value='1'></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="packageDataType" v-if="curComponent == 'PACKUP_PACKAGE'">
            <el-select class="y-w-136" :popper-append-to-body="false" v-model="form.packageDataType" placeholder="上车类型" :clearable="true">
              <el-option label="建包上车" value='1'></el-option>
              <el-option label="散件上车" value='0'></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="buildPageName" v-if="curComponent == 'PACKAGE_PRINT'">
            <el-input class="y-w-136" v-model.trim="form.buildPageName" placeholder="建包名称" :clearable="true"></el-input>
          </el-form-item>
          <el-form-item label="" prop="packageWaybillNo" v-if="curComponent == 'PACKAGE_PRINT'">
            <el-input class="y-w-136" v-model.trim="form.packageWaybillNo" placeholder="包签号" :clearable="true"></el-input>
          </el-form-item>
          <el-form-item label="" prop="shortAddress">
            <el-input class="y-w-136" v-model.trim="form.shortAddress" placeholder="一段码" :clearable="true"></el-input>
          </el-form-item>
          <el-form-item label="" prop="orderNo" v-if="curComponent == 'BULK_PRINT'">
            <el-input class="y-w-180" v-model.trim="form.orderNo" placeholder="订单号" :clearable="true"></el-input>
          </el-form-item>
        </template>
        <!--<el-form-item label="" prop="productCode" v-if="curComponent =='waybillDetailPage'">
          <el-select class="y-w-136" :popper-append-to-body="false" v-model="form.productCode" placeholder="请选择商品" :clearable="true">
            <el-option
              v-for="(item, index) in productList"
              :key="index"
              :label="item.productName"
              :value="item.productId"></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="" prop="mailNo">
          <el-input class="y-w-180" v-model.trim="form.mailNo" placeholder="运单号" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item style="float:right;">
          <el-button
            icon="el-icon-search"
            type="primary"
            @click="searchFormData">查询
          </el-button>
          <el-button class="normal-btn" type="button" @click="resetForm('ruleForm')"><i class="el-icon-refresh-left y-fc-4C84FF"></i>重置</el-button>
        </el-form-item>
        <div style="clear:both"></div>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import netAPI from '@/api';
import { dateFormat, getShortcutsMap } from '@/utils/util';
export default {
  name: 'searchOptions',
  props: {
    curComponent: {
      type: String,
      default: ''
    },
    searchForm: {
      type: Object,
      default: function () {
        return {};
      }
    },
    storList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    productList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    fromPage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      curShortcutName: '',
      pickerOptions1: {
        disabledDate(time) {
          // 只能选择1年内的数据
          return (
            time.getTime() > new Date(`${dateFormat(new Date(), 'yyyy-MM-dd')} 23:59:59`).getTime() ||
            time.getTime() < new Date(new Date().setDate(new Date().getDate() - 30))
          );
        }
      },
      form: this.searchForm,
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  mounted() {},
  methods: {
    // 查询数据
    searchFormData() {
      this.$emit('searchFormData', this.form);
    },
    // 重置按钮
    resetForm(formName) {
      let mallCode = this.form.mallCode;
      this.$refs[formName].resetFields();
      this.form.mallCode = mallCode;
      this.initTime();
      this.$emit('resetForm', this.form);
    },
    // 初始化时间
    initTime() {
      let createTime = [];
      let agoDays = '';
      if(localStorage.getItem(`JBDY_${this.curComponent}_customrange`)) {
        let customrange = JSON.parse(localStorage.getItem(`JBDY_${this.curComponent}_customrange`));
        agoDays = new Date(new Date().getTime() - customrange.dateRange * 24 * 3600 * 1000);
        this.curShortcutName = customrange.curShortcutName;
        if(this.curShortcutName === 'customRange') {
          // 只有是记住天数选项才使用记住的那个天数时间
          createTime = [
            `${dateFormat(agoDays, 'yyyy-MM-dd')} 00:00:00`,
            `${dateFormat(new Date(), 'yyyy-MM-dd')} 23:59:59`
          ]
        } else {
          let shortcutsMap = getShortcutsMap()
          createTime = shortcutsMap[this.curShortcutName];
        }
        this.$set(this.form, 'createTime', createTime);
      } else {
        agoDays = new Date();//new Date(new Date().getTime() - 6 * 24 * 3600 * 1000);
        // 初始化下单日期
        createTime = [
          `${dateFormat(agoDays, 'yyyy-MM-dd')} 00:00:00`,
          `${dateFormat(new Date(), 'yyyy-MM-dd')} 23:59:59`
        ];
        this.$set(this.form, 'createTime', createTime);
      }
    },
    goback() {
      this.$router.push({name: 'packagePrint', params: {activeName: this.fromPage}});
    }
  }
};
</script>
